module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-yellow.17781ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-yellow.svg
// module id = 0oPL
// module chunks = 82